module.exports = __webpack_public_path__ + "img/img_9.0570a61a.png";